module.exports = __webpack_public_path__ + "static/media/upload-img-new.c3e1f8fd.svg";